var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ height: _vm.contentHeight })},[_c('RouterView'),_c('BtnDialog'),(_vm.appLoaded)?_c('CookieConsent',{on:{"cookie-consent":_vm.handleCookieConsent}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }